<template>
  <div class="pop-wrap" v-if="qrImgUrl">
    <transition name="fadeSmall">
      <div class="pop-small" v-show="showSmall" @click="showBigEvent"></div>
    </transition>

    <transition name="fadeBig">
      <div class="pop-big" v-show="showBig">
        <div class="pop-content">
          <div class="left-bag"></div>
          <!-- <div class="right-bag">
            <p>扫描二维码进入</p>
            <img :src="qrImgUrl">
          </div> -->
          <div class="closeBtn" @click="showSmallEvent"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      showSmall: false,
      showBig: true,
      timer1: null,
      timer2: null
    }
  },
  computed: {
    ...mapState([
      'name',
      'qrImgUrl'
    ])
  },
  watch: {
    name: function(oldV, newV) {
      if (oldV != newV) {
        this.showSmallEvent()
      }
    }
  },
  created() {
    this.packUpPop()
  },
  methods: {
    showBigEvent() {
      this.showSmall = false
      setTimeout(() => {
        this.showBig = true
      }, 500)
      this.packUpPop()
    },
    showSmallEvent() {
      this.showBig = false
      setTimeout(()=> {
        this.showSmall = true
      }, 800)
    },
    packUpPop() {
      let that = this
      that.timer1 && clearTimeout(that.timer1)
      that.timer2 && clearTimeout(that.timer2)
      that.timer1 = setTimeout(() => {
        that.showBig = false
      }, 5000)

      that.timer2 = setTimeout(() => {
        that.showSmall = true
      }, 5800)
    }
  }
}
</script>

<style scoped lang="less">
  .pop-wrap {
    height: 0!important;
    .pop-small {
      height: 155px;
      width: 157px;
      position: fixed;
      left: 0;
      bottom: 70px;
      background: url('../common/img/new/popSmall.png');
      background-size: 100% 100%;
      z-index: 999;
    }

    .pop-big {
      height: 176px;
      width: 100%;
      position: fixed;
      left: 0;
      bottom: 0;
      background:rgba(1,15,32, .95);
      z-index: 999;
      .pop-content {
        width: 1000px;
        height: 100%;
        margin: 0 auto;
        background: url('../common/img/new/popBg.png');
        background-size: 100% 100%;
        position: relative;
        .left-bag {
          width: 160px;
          height: 173px;
          position: absolute;
          bottom: 23px;
          left: 46px;
          background: url('../common/img/new/popBigIcon.png');
          background-size: 100% 100%;
        }
        .right-bag {
          width: 160px;
          height: 100%;
          background:rgba(255,255,255,.21);
          position: absolute;
          top: 0;
          right: 52px;
          p {
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC,Arial, Helvetica, sans-serif;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:20px;
            text-align: center;
            margin: 12px 0 10px;
          }
          img {
            width: 118px;
            height: 118px;
            margin: 0 auto;
            border-radius: 5px;
          }
        }
        .closeBtn {
          width: 20px;
          height: 20px;
          background: url('../common/img/new/popClose.png');
          background-size: 100% 100%;
          position: absolute;
          top: 18px;
          right: 3px;
        }
      }
    }

    .fadeSmall-enter-active {
      animation: fadeBig .5s;
    }
    .fadeSmall-leave-active {
      animation: fadeBig .5s reverse;
    }

    .fadeBig-enter-active {
      animation: fadeBig .75s;
    }
    .fadeBig-leave-active {
      animation: fadeBig .75s reverse;
    }
    @keyframes fadeBig {
      0% {
        -webkit-transform: translate3d(-100%,0,0);
        transform: translate3d(-100%,0,0);
      }
      to {
        -webkit-transform: translateZ(0);
        transform:translateZ(0);
      }
    }
  }
</style>